<!-- 
 01-01-2025
 Copyright (c) 2016 Aruba. All Rights Reserved.  
 -->
<div class="modal-header">
    <div class="modal-title h4" [innerHTML]="'navbar.questionPecPlus.title' | translate"></div>
    <button aria-label="Close" data-dismiss="modal" class="close" type="button" (click)="closeModal()">
        <span aria-hidden="true">{{'main.charX' | translate}}</span>
    </button>
</div>

<div class="modal-body">
    <div [innerHTML]="'navbar.questionPecPlus.subTitle' | translate" class="text-center">
        La tua PEC è già adeguata agli standard europei.</div>
    <div [innerHTML]="'navbar.questionPecPlus.subTitle2' | translate" class="text-center mb-3">
        Dal 2024 potrai inviare PEC in tutta Europa.</div>
    <div class="row">
        <div class="col-12 col-lg-6">
            <div class="modalQuestionSx p-3 pb-5"> 
                <p class="font-18" [innerHTML]="'navbar.questionPecPlus.questionTitle' | translate">
                    Cosa puoi fare adesso?</p>
                <p class="font-14" [innerHTML]="'navbar.questionPecPlus.questionDesc' | translate">
                    Puoi continuare a </p>
                <p class="font-14" [innerHTML]="'navbar.questionPecPlus.questionDesc2' | translate">
                    In più hai la spunta blu di conformità</p>
                <div style="display: flex">
                        <svg-icon src="content/images/icons/mobile-shield.svg"></svg-icon>
                        <span [innerHTML]="'navbar.questionPecPlus.questionSafe' | translate" class="ms-2">Più sicura:
                        </span>
                </div>
                <div style="display: flex" class="mt-3">
                    <svg-icon src="content/images/icons/user-shield-circle.svg"></svg-icon>
                    <span [innerHTML]="'navbar.questionPecPlus.questionReliable' | translate" class="ms-2">
                        Più attendibile</span>
                </div>
            </div>
        </div>
        <div class="col-11 col-lg-6 modalQuestionDx">
            <div class="p-3">
                <p class="font-18" [innerHTML]="'navbar.questionPecPlus.question2024Title' | translate">
                    Cosa potrai fare dal 2024?</p>
                <p class="font-14" [innerHTML]="'navbar.questionPecPlus.question2024Desc' | translate">
                    Potrai inviare messaggi PEC anche in Europa</p>
                <p class="font-14" [innerHTML]="'navbar.questionPecPlus.question2024Text' | translate">
                    Anche se la tua PEC è già conforme agli standard europei, occorre ancora aspettare che 
                    gli altri stati si adeguino.</p>
            </div>
        </div>
    </div>
</div>
